import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { replaceInArray } from '@rd-web-markets/shared/dist/util/arrayUtils/arrayUtils';
import { useTranslation } from 'react-i18next';
const api = buildService('/elster_asset_instances/{id}/fundings', {
  only: ['all', 'get', 'update', 'delete', 'create']
});
const elsterAssetInstanceFundingsService = {
  useFetchAll: function (assetInstanceId, setLoading) {
    let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const [fundings, setFundings, fetchFundings] = serviceMethods.useFetch({
      callback: useCallback(async () => await api.all(assetInstanceId), [assetInstanceId]),
      setLoading: setLoading,
      fetchImmediately
    });
    return [fundings, setFundings, fetchFundings];
  },
  useCreate: (assetInstanceId, setLoading, setFundings) => {
    const createFunding = serviceMethods.useCreate({
      callback: useCallback(async params => {
        const newFunding = await api.create(assetInstanceId, params);
        if (setFundings) {
          setFundings(fundings => {
            return [...fundings, newFunding];
          });
        }
        return newFunding;
      }, [assetInstanceId, setFundings]),
      setLoading: setLoading
    });
    return [createFunding];
  },
  useUpdate: (assetInstanceId, setLoading, setFundings) => {
    const updateFunding = serviceMethods.useUpdate({
      callback: useCallback(async funding => {
        const updatedFunding = await api.update(assetInstanceId, funding.id, {
          funding
        });
        if (setFundings) {
          setFundings(replaceInArray(f => f.id === updatedFunding.id, updatedFunding));
        }
        return updatedFunding;
      }, [assetInstanceId, setFundings]),
      setLoading: setLoading
    });
    return [updateFunding];
  },
  useDelete: (assetInstanceId, setLoading, setFundings, t) => {
    const deleteFunding = serviceMethods.useDelete({
      callback: useCallback(async funding => {
        const confirmationMessage = t('are_you_sure_you_want_to_remove_this_funding') + ': ' + (funding.notes || t('funding'));
        if (!window.confirm(confirmationMessage)) {
          return;
        }
        await api.delete(assetInstanceId, funding.id);
        if (setFundings) {
          setFundings(fundings => {
            const fundingsFiltered = fundings.filter(f => f.id !== funding.id);
            return [...fundingsFiltered];
          });
        }
      }, [assetInstanceId, setFundings, t]),
      setLoading: setLoading
    });
    return [deleteFunding];
  }
};
elsterAssetInstanceFundingsService.useCrud = function (assetInstanceId, setLoading) {
  let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {
    t
  } = useTranslation();
  const [fundings, setFundings, fetchFundings] = elsterAssetInstanceFundingsService.useFetchAll(assetInstanceId, setLoading, fetchImmediately);
  const [createFunding] = elsterAssetInstanceFundingsService.useCreate(assetInstanceId, setLoading, setFundings);
  const [updateFunding] = elsterAssetInstanceFundingsService.useUpdate(assetInstanceId, setLoading, setFundings);
  const [deleteFunding] = elsterAssetInstanceFundingsService.useDelete(assetInstanceId, setLoading, setFundings, t);
  return {
    fundings,
    setFundings,
    fetchFundings,
    createFunding,
    updateFunding,
    deleteFunding
  };
};
export default elsterAssetInstanceFundingsService;